import React from 'react';

import { Formik, Field } from 'formik';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';

const userUpdateGeneralSchema = Yup.object().shape({
    first_name: Yup.string().min(2).max(255).required('This value is required'),
    last_name: Yup.string().min(2).max(255).required('This value is required'),
    email: Yup.string().email().required('This value is required'),
});

export default function UserPersonalDetailsGeneralForm(props) {
    return (
        <Formik
            initialValues={{
                first_name: props.user ? props.user.first_name : '',
                last_name: props.user ? props.user.last_name : '',
                email: props.user ? props.user.email : '',
            }}
            validationSchema={userUpdateGeneralSchema}
            onSubmit={async (values, actions) => {
                let data = { ...values };
                await props.updateProfile(data);
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <div>
                    <div className={'row'}>
                        <div className={'col-12'}>
                            <div className={'card bg-white border-0 rounded-15px py-2 shadow'}>
                                <div className="">
                                    <div className={'card-body'}>
                                        <div className="form-group row">
                                            <label htmlFor="first_name" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                                First name
                                            </label>
                                            <div className="col-12">
                                                <Field
                                                    type="text"
                                                    className={
                                                        errors.first_name && touched.first_name
                                                            ? 'form-control is-invalid border border-danger'
                                                            : 'form-control'
                                                    }
                                                    name="first_name"
                                                    placeholder="First Name"
                                                />
                                                {errors.first_name && touched.first_name && <div className="text-danger">{errors.first_name}</div>}
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="last_name" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                                Last name
                                            </label>
                                            <div className="col-12">
                                                <Field
                                                    type="text"
                                                    className={
                                                        errors.last_name && touched.last_name ? 'form-control is-invalid border border-danger' : 'form-control'
                                                    }
                                                    name="last_name"
                                                    placeholder="Last Name"
                                                />
                                                {errors.last_name && touched.last_name && <div className="text-danger">{errors.last_name}</div>}
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="email" className="col-12 col-form-label font-weight-bold" style={{ fontSize: '14px' }}>
                                                Email
                                            </label>
                                            <div className="col-12">
                                                <Field
                                                    type="text"
                                                    className={errors.email && touched.email ? 'form-control is-invalid border border-danger' : 'form-control'}
                                                    name="email"
                                                    placeholder="Email"
                                                />
                                                {errors.email && touched.email && <div className="text-danger">{errors.email}</div>}
                                            </div>
                                        </div>

                                        <div className="row">
                                            <div className="col-12 d-flex justify-content-end">
                                                <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                                                    Save
                                                </Button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </Formik>
    );
}
